(function () {
    'use strict';

    angular.module('elogbooks.common.dashboard-layout', [
        // 'elogbooks.common.conversations'
    ]);
})();
